<template>
  <div class="login-bg login-bg-dialog">
    <div class="login-center">
      <div class="login-tt">
        <i></i>
        <span>{{ $t('message.login') }}</span>
        <i></i>
      </div>
      <div class="login-tten">Vayo-3D PLT</div>
      <div class="login-line">
        <div class="line-half line-half-active"></div>
        <div class="line-half"></div>
      </div>
      <div class="login-form">
        <el-form :rules="rules" ref="ruleForm" :model="ruleForm" label-width="0px">
          <el-form-item label="" prop="userName">
            <el-input type="text" :placeholder="$t('message.enterUsername')" v-model="ruleForm.userName" class="login-input" />
          </el-form-item>
          <div class="login-blank"></div>
          <el-form-item label="" prop="password" class="password-item">
            <el-input :type="isShow ? 'text' : 'password'" :placeholder="$t('message.enterPass')" v-model="ruleForm.password" class="login-input" />
            <img src="@/assets/images/eye2.png" v-show="!isShow" @click="changeEye(true)" alt="" class="eye" />
            <img src="@/assets/images/eye.png" v-show="isShow" @click="changeEye(false)" alt="" class="eye" />
          </el-form-item>
          <!-- <div class="login-rem">
            <el-checkbox v-model="isRemember" class="login-check">{{ $t('message.remPass') }}</el-checkbox>
          </div> -->
          <div class="login-tj" @click="submitMethods">{{ $t('message.login') }}</div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import MD5 from 'crypto-js/md5';
import request from '@/axios/request.js';

export default {
  data () {
    return {
      ruleForm: {
        userName: '',
        password: ''
      },
      rules: {
        userName: [
          { required: true, message: this.$t('message.enterUsername'), trigger: 'change' }
        ],
        password: [
          { required: true, message: this.$t('message.enterPass'), trigger: 'change' }
        ]
      },
      isShow: false
    }
  },
	methods: {
    changeEye (val) {
      this.isShow = val;
    },
    async loginVoid () {
      let params = {
        userName: this.ruleForm.userName,
        password: MD5(this.ruleForm.password).toString()
      };
      try {
        let res = await request.post('/auth/login', params);
        if (res.code == 200) {
          let token = res.data.token;
          let userName = res.data.userName;
          let userId = res.data.userId;
          window.sessionStorage.setItem('token', token);
          window.sessionStorage.setItem('userName', userName);
          window.sessionStorage.setItem('userId', userId);
          window.sessionStorage.setItem('roleName', res.data.roleName);
          window.sessionStorage.setItem('roleNameEn', res.data.roleNameEn);
          window.sessionStorage.setItem('roleNameTw', res.data.roleNameTw);

          let isRemember = window.localStorage.getItem('isRemember');
          if (isRemember && isRemember == 'yes') {
						// let remObj = {
            //   databaseId: this.$store.state.databaseTempId,
            //   userName: userName,
            //   password: this.ruleForm.password
            // };
            // window.localStorage.setItem('remObj', JSON.stringify(remObj));
            let objDatabase = {
              userName: userName,
              password: this.ruleForm.password
            };
            window.localStorage.setItem(this.$store.state.databaseTempId, JSON.stringify(objDatabase));
            window.localStorage.setItem('currentDatabaseId', this.$store.state.databaseTempId);
            window.localStorage.setItem('currentDatabaseName', this.$store.state.databaseTempName);
          }

          try {
            let res2 = await request.post('/auth/getInfo', params);
            if (res2.code == 200) {
              let permissionList = res2.data.permissionList;
              permissionList = JSON.stringify(permissionList);
              window.sessionStorage.setItem('permissionList', permissionList);
              let menuList = res2.data.menuList;
              menuList = JSON.stringify(menuList);
              window.sessionStorage.setItem('menuList', menuList);
              window.location.reload();
            }
          } catch (error2) {
            this.$message({
              message: error2,
              type: 'warning'
            });
          }
        } else {
          window.sessionStorage.setItem('databaseId', this.$store.state.databaseYuanId);
          window.sessionStorage.setItem('databaseName', this.$store.state.databaseYuanName);
          this.$message({
            message: res.msg || 'error',
            type: 'warning'
          });
        }
      } catch (error) {
        window.sessionStorage.setItem('databaseId', this.$store.state.databaseYuanId);
        window.sessionStorage.setItem('databaseName', this.$store.state.databaseYuanName);
        this.$message({
          message: error,
          type: 'warning'
        });
      }
    },
		submitMethods () {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          window.sessionStorage.setItem('databaseId', this.$store.state.databaseTempId);
          window.sessionStorage.setItem('databaseName', this.$store.state.databaseTempName);
          this.loginVoid();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
		}
	}
}
</script>